import { render } from "./WidgetStandardBox.vue?vue&type=template&id=7d3c1419"
import script from "./WidgetStandardBox.vue?vue&type=script&lang=js"
export * from "./WidgetStandardBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__